import { FunctionComponent } from "react";
import { Container } from "../../../../components/formulario/styled";
import HeaderCheckinMembros from "./header";
import TableConexao from ".";


interface ContainerMembroProps {

}

const ContainerMembroCheckin: FunctionComponent<ContainerMembroProps> = () => {
  return ( <>
    <Container>
      <HeaderCheckinMembros/>
      <TableConexao />
    </Container>
  </> );
}

export default ContainerMembroCheckin;
